import React, { useContext } from 'react';
import { EncoreContext, encoreContextKeyword, encoreContextStatus, getStatus } from "../../../contexts/EncoreContext";
import { Experimental__IconTwitter } from "../../Experimental__Icon/icons/Experimental__IconTwitter";
import { Icon } from "../";
export function IconTwitter(props) {
  var config = useContext(EncoreContext);
  var status = getStatus(encoreContextKeyword.icon, config);

  if (status !== encoreContextStatus.deprecated) {
    return /*#__PURE__*/React.createElement(Experimental__IconTwitter, props);
  }

  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    dangerouslySetInnerHTML: {
      __html: "<path d=\"M8.33 21A12.59 12.59 0 0021 8.32v-.58a9.07 9.07 0 002.22-2.31 8.9 8.9 0 01-2.56.7 4.47 4.47 0 002-2.47 8.93 8.93 0 01-2.83 1.08 4.46 4.46 0 00-7.6 4.06A12.65 12.65 0 013 4.16a4.46 4.46 0 001.38 5.95 4.42 4.42 0 01-2-.56v.06A4.46 4.46 0 005.95 14a4.45 4.45 0 01-2 .08 4.46 4.46 0 004.16 3.1 8.94 8.94 0 01-5.54 1.91A9.07 9.07 0 011.5 19a12.62 12.62 0 006.83 2\" fill=\"#181818\"/>"
    }
  }));
}
export default IconTwitter;